export const buildRefCodeDataOrEmpty = (data) => {
    var _a, _b, _c;
    if (!data) {
        return {
            isEmpty: true,
            defaultCode: '',
            defaultCodeTimesUsed: 0,
        };
    }
    const result = {
        isEmpty: (_a = data.isEmpty) !== null && _a !== void 0 ? _a : false,
        defaultCode: (_b = data.defaultCode) !== null && _b !== void 0 ? _b : '',
        defaultCodeTimesUsed: (_c = data.defaultCodeTimesUsed) !== null && _c !== void 0 ? _c : 0,
    };
    return result;
};
